export default "__VITE_ASSET__0bb84c35__"